module.exports = __webpack_public_path__ + "assets/assets/images/illustrations/register-success-illustration.16bf4532.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/illustrations/register-success-illustration.png
// module id = 342
// module chunks = 2